var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{ref:"svg",staticClass:"pointer-events-none gl-absolute gl-z-0 gl-h-full"},[_c('line',{attrs:{"x1":_vm.startCoordinate.x,"y1":_vm.startCoordinate.y,"x2":_vm.endCoordinate.x,"y2":_vm.endCoordinate.y,"stroke":"#D1D5DB","stroke-width":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }